import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { SectionLabel, SectionHeading, SecondaryButton } from './ui/UI';
import { ArrowRight } from 'lucide-react';
const flow = ['Advisory', 'Baseline', 'Missing signals', 'Validation plan', 'Remediation', 'Readiness report'];
export function ThreatCenterTeaser() {
  return <section className="relative w-full py-32 border-t border-white/5" data-id="element-1422">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-1423">
        <SectionLabel number="06" label="Threat Center" className="mb-8" data-id="element-1424" />

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16" data-id="element-1425">
          <div className="lg:col-span-7" data-id="element-1426">
            <SectionHeading size="xl" data-id="element-1427">
              New threat advisory?
              <br data-id="element-1428" />
              <span className="text-white/40" data-id="element-1429">
                Turn it into a validation plan.
              </span>
            </SectionHeading>
          </div>
          <div className="lg:col-span-5 lg:pt-4" data-id="element-1430">
            <p className="text-lg text-white/60 leading-relaxed mb-6" data-id="element-1431">
              Periscan Threat Center converts CISA alerts, CVEs, vendor
              advisories, TTPs, and threat intel into customer-specific
              validation plans, remediation actions, fix verification, and
              readiness reports.
            </p>
            <SecondaryButton href="/early-access" size="md" data-id="element-1432">
              Validate an Advisory
            </SecondaryButton>
          </div>
        </div>

        <div className="p-8 rounded-2xl bg-[#070a0e] border border-white/5" data-id="element-1433">
          <p className="font-mono text-[10px] uppercase tracking-widest text-[#1a8fd4] mb-6" data-id="element-1434">
            Advisory Workflow
          </p>
          <div className="flex flex-wrap items-center gap-3" data-id="element-1435">
            {flow.map((node, i) => <Fragment key={i} data-id="element-1436">
                <div className="px-4 py-2.5 rounded-lg bg-[#1a8fd4]/10 border border-[#1a8fd4]/30" data-id="element-1437">
                  <span className="font-mono text-xs text-white" data-id="element-1438">{node}</span>
                </div>
                {i < flow.length - 1 && <motion.div initial={{
              width: 0
            }} whileInView={{
              width: 'auto'
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: i * 0.15
            }} className="flex items-center" data-id="element-1439">
                    <ArrowRight className="w-4 h-4 text-[#1a8fd4]/60" data-id="element-1440" />
                  </motion.div>}
              </Fragment>)}
          </div>
        </div>
      </div>
    </section>;
}